import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';

function SystemAgreementsPageView({
  rows,
  newName,
  setNewName,
  isLoading,
  isSaving,
  error,
  success,
  deleteTargetId,
  dragSourceId,
  handleAdd,
  startEdit,
  cancelEdit,
  updateDraft,
  saveEdit,
  requestDeleteRow,
  cancelDeleteRow,
  confirmDeleteRow,
  handleDragStart,
  handleDragEnd,
  handleDrop,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('agreements.savingInfo') : ''}
        error={error}
        success={success}
      />
      <PageHeader title={t('agreements.title')} subtitle={t('agreements.subtitle')} />

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <form className="row g-2 mb-3" onSubmit={handleAdd}>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder={t('agreements.newAgreementPlaceholder')}
                value={newName}
                onChange={(event) => setNewName(event.target.value)}
                disabled={isLoading || isSaving}
              />
            </div>
            <div className="col-md-3 d-grid">
              <button type="submit" className="btn btn-primary" disabled={isLoading || isSaving}>{t('agreements.addRow')}</button>
            </div>
          </form>
        </div>

        <div className="card card-body mt-3">
          <LoadingContainer isLoading={isLoading} hasData={rows.length > 0}>
              <table className="table search-table align-middle text-nowrap mb-0 app-agreements-table">
                <tbody>
                  {rows.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center text-muted">{t('agreements.noAgreementsYet')}</td>
                    </tr>
                  ) : null}

                  {rows.map((row) => (
                    <tr
                      key={row.id}
                      draggable={!isSaving}
                      onDragStart={() => handleDragStart(row.id)}
                      onDragEnd={handleDragEnd}
                      onDragOver={(event) => event.preventDefault()}
                      onDrop={() => handleDrop(row.id)}
                      className={dragSourceId === row.id ? 'opacity-50' : ''}
                    >
                      <td className="text-nowrap">
                        <span className="text-muted" title={t('agreements.dragToReorder')}>
                          <i className="fa fa-grip-vertical"></i>
                        </span>
                      </td>
                      <td>
                        {row.isEditing ? (
                          <input
                            className="form-control"
                            value={row.draftName}
                            onChange={(event) => updateDraft(row.id, event.target.value)}
                            disabled={isSaving}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter') {
                                event.preventDefault();
                                saveEdit(row.id);
                              }
                            }}
                          />
                        ) : (
                          row.name
                        )}
                      </td>
                      <td className="text-nowrap text-end">
                        <div className="d-flex align-items-center justify-content-end gap-2">
                          {!row.isEditing ? (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={() => startEdit(row.id)}
                              disabled={isSaving}
                              title="Edit"
                            >
                              <i className="fa fa-pen"></i>
                            </button>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => saveEdit(row.id)}
                                disabled={isSaving}
                                title="Apply"
                              >
                                <i className="fa fa-check"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-default"
                                onClick={() => cancelEdit(row.id)}
                                disabled={isSaving}
                                title="Cancel"
                              >
                                <i className="fa fa-xmark"></i>
                              </button>
                            </>
                          )}
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => requestDeleteRow(row.id)}
                            disabled={isSaving}
                            title="Delete"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
          </LoadingContainer>
        </div>
      </div>

      {deleteTargetId ? (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{t('agreements.deleteTitle')}</h5>
                  <button type="button" className="btn-close" onClick={cancelDeleteRow}></button>
                </div>
                <div className="modal-body">
                  <p className="mb-0">{t('agreements.deleteConfirm')}</p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default" onClick={cancelDeleteRow} disabled={isSaving}>{t('common.cancel')}</button>
                  <button type="button" className="btn btn-danger" onClick={confirmDeleteRow} disabled={isSaving}>{t('common.delete')}</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      ) : null}
    </div>
  );
}

export default SystemAgreementsPageView;
